<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('设备编号')">
              <j-input :placeholder="$t('输入设备编号模糊查询')" v-model="queryParam.deviceId"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('设备名称')">
              <j-input :placeholder="$t('输入设备名称模糊查询')" v-model="queryParam.deviceName"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('仪表类型')">
              <j-dict-select-tag v-model="queryParam.deviceType" :placeholder="$t('请选择设备类型')" dictCode="wq_device_type" ></j-dict-select-tag>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('电池状态')">
                <a-select v-model="queryParam.batteryStatus" :placeholder="$t('请选择电池状态')">
                  <a-select-option v-for="data in batterystatusList" :key="data.key" :value="data.key">
                    {{data.title}}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('上报方式')">
                <a-select v-model="queryParam.meterSendWay" :placeholder="$t('请选择上报方式')">
                  <a-select-option v-for="(item,key) in tuopuruiSendWayObj" :value="key" :key="key">
                    {{item}}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('传感器状态')">
                <a-select v-model="queryParam.sensorStatus" :placeholder="$t('请选择传感器状态')">
                  <a-select-option v-for="data in sensorstatusList" :key="data.key" :value="data.key">
                    {{data.title}}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
                  <a-form-model-item :label="$t('上报时间')">
                    <a-range-picker
                      v-model="date"
                      :placeholder="[$t('查询起始时间'), $t('查询结束时间')]"
                      format="YYYY-MM-DD"
                      @change="onDateRangeChange"
                    />
                  </a-form-model-item>
                </a-col>
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">

      <a-button type="primary" icon="download" @click="handleExportXls($t('管网监测-历史数据'))">{{ $t('导出') }}</a-button>
    </div>
    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">{{ $t('详情') }}</a>
        </span>

      </a-table>
    </div>

    <part-pw-history-meterdatarecord-modal ref="modalForm" @ok="modalFormOk"></part-pw-history-meterdatarecord-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import PartPwHistoryMeterdatarecordModal from './modules/PartPwHistoryMeterdatarecordModal'
  import {tuopuruiSendWayObj} from '@/utils/constants/protocolConstant'
  import {filterDictTextByCache} from '@/components/dict/JDictSelectUtil'
  import JInput from '@/components/jeecg/JInput'

  export default {
    name: 'PartPwHistoryMeterdatarecordList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      PartPwHistoryMeterdatarecordModal,
      JInput
    },
    data () {
      return {
        description: '管网监测历史数据管理页面',
        tuopuruiSendWayObj,
        url: {
          list: "/jeecg-charge/wq/partPWHistoryMeterdatarecord/list",
          exportXlsUrl: "/jeecg-charge/wq/partPWHistoryMeterdatarecord/exportXls",

        },
        dictOptions:{},
        /* 排序参数 */
        isorter:{
          column: 'systime',
          order: 'desc',
        },
        dateType: 2
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：下拉选项使用 computed 以响应语言切换
      metertypeList() {
        return [{key: 1,title: this.$t('NB压力表')},{key: 2,title: this.$t('NB液位计')},{key: 3,title: this.$t('4G压力表')},{key: 4,title: this.$t('4G液位计')}]
      },
      batterystatusList() {
        return [{key: 0,title: this.$t('正常')},{key:1,title: this.$t('欠压')}]
      },
      sensorstatusList() {
        return [{key: 0,title: this.$t('正常')},{key:1,title: this.$t('异常')}]
      },
      // i18n：表头使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('仪表类型'),
            align:"center",
            dataIndex: 'deviceType',
            customRender: (text) => {
              return filterDictTextByCache('wq_device_type', text);
              //let obj = {1: 'NB压力表',2: 'NB液位计',3: '4G压力表',4: '4G液位计'}
              //return obj[text]?obj[text]: '未知'
            }
          },
          {
            title: this.$t('设备编号'),
            align:"center",
            dataIndex: 'meterid'
          },{
            title: this.$t('设备名称'),
            align:"center",
            dataIndex: 'deviceName'
          },{
            title: this.$t('安装位置'),
            align:"center",
            dataIndex: 'deviceLocation'
          },
          {
            title: this.$t('上报时间'),
            align:"center",
            dataIndex: 'systime'
          },
          {
            title: this.$t('压力值(MPa)/液位值(m)'),
            align:"center",
            dataIndex: 'pvalue'
          },
          {
            title: this.$t('温度值(℃)'),
            align:"center",
            dataIndex: 'tepvalue'
          },
          {
            title: this.$t('信号值'),
            align:"center",
            dataIndex: 'signDb'
          },
          {
            title: this.$t('电量(%)'),
            align:"center",
            dataIndex: 'battery'
          },
          {
            title: this.$t('电池状态'),
            align:"center",
            dataIndex: 'batterystatus',
            customRender: (text) => {
              let obj = {0: this.$t('正常'),1: this.$t('欠压')}
              return obj[text]?obj[text]: this.$t('未知')
            }
          },
          {
            title: this.$t('上报方式'),
            align:"center",
            dataIndex: 'metersendway',
            customRender: (text) => {
              let obj = tuopuruiSendWayObj
              return obj[text]?this.$t(obj[text]): this.$t('未知')
            }
          },
          {
            title: this.$t('传感器状态'),
            align:"center",
            dataIndex: 'sensorstatus',
            customRender: (text) => {
              let obj = {0: this.$t('正常'),1: this.$t('异常')}
              return obj[text]?obj[text]: this.$t('未知')
            }
          },/*
          {
            title:'告警状态',
            align:"center",
            dataIndex: 'warnstatus',
            customRender:function (text,record) {
              let waterWarn = {'-1': '离线',0: '正常',10: '液位下限报警',20: '液位上限报警',1: '温度下限报警',2: '温度上限报警',
                11: '液位下限报警、温度下限报警',12: '液位下限报警、温度上限报警',21: '液位上限报警 温度下限报警',22: '液位上限报警 温度上限报警',9:'电池电量报警'};
              let pressWarn = {'-1': '离线',0: '正常',10: '压力下限报警',20: '压力上限报警',1: '温度下限报警',2: '温度上限报警',
                11: '压力下限报警、温度下限报警',12: '压力下限报警、温度上限报警',21: '压力上限报警 温度下限报警',22: '压力上限报警 温度上限报警',9:'电池电量报警'};
              if(record.metertype == 1||record.metertype == 3) {
                return pressWarn[text]?pressWarn[text]: '未知'
              }else if(record.metertype == 2||record.metertype == 4){
                return waterWarn[text]?waterWarn[text]: '未知'
              }
            }
          },*/
          {
            title: this.$t('告警状态'),
            align:"center",
            dataIndex: 'datainfo',
            customRender: (text,record) => {
              if(record.warnstatus == 0){
                return this.$t('正常');
              }else{
                return text;
              }
            }
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      initDictConfig(){
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
